export class DadosBeneficiario {
  nomeBeneficiario: string;
  cpf: string;
  rg: string;
  dataNascimento: string;
  sexo: string;
  email1: string;
  email2: string;
}
